import React, { useState, useEffect } from "react";
import Grid from "@mui/material/Grid";
import axios from "axios";
// Material Dashboard 2 React components
import MDBox from "components/MDBox";

// Material Dashboard 2 React example components
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import Footer from "examples/Footer";
import ReportsBarChart from "examples/Charts/BarCharts/ReportsBarChart";
import ReportsLineChart from "examples/Charts/LineCharts/ReportsLineChart";
import ComplexStatisticsCard from "examples/Cards/StatisticsCards/ComplexStatisticsCard";

// Data
import reportsBarChartData from "layouts/dashboard/data/reportsBarChartData";
import reportsLineChartData from "layouts/dashboard/data/reportsLineChartData";

// Dashboard components

function Dashboard() {
  const [programCount, setProgramCount] = useState(0);
  const [branchCount, setBranchCount] = useState(0);
  const [studentCount, setStudentCount] = useState(0);

  const [pending, setPending] = useState(0);
  const [completed, setCompleted] = useState(0);

  const user = JSON.parse(sessionStorage.getItem("user"));

  // 🔥 BACKEND RETURNS: roles: ["ADMIN"]
  const role = user?.roles?.[0] || "GUEST";
  const roleId = user.core_user_roles?.[0]?.role_id;
  const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;

  useEffect(() => {
    if (roleId === 1 || roleId == 4) {
      fetchPrograms();
      fetchBranches();
      fetchStudents();
    }

    if (roleId === "6") {
      // Add Valuator dashboard API calls if needed
    }
  }, [role]);
  useEffect(() => {
    if (roleId === 6) {
      fetchValuationStats();
    }
  }, [roleId]);

  const fetchValuationStats = async () => {
    try {
      const res = await axios.get(
        `${API_BASE_URL}/api/script-valuation/stats/${user.client_id}/${user.college_id}/${user.user_email}`
      );
      const { pending, completed } = res.data.data;
      setPending(pending);
      setCompleted(completed);
    } catch (err) {
      console.error("Error fetching script stats", err);
    }
  };
  const fetchPrograms = async () => {
    try {
      const res = await axios.get(
        `${API_BASE_URL}/api/dashboard/program-count/${user.client_id}/${user.college_id}`
      );
      setProgramCount(res.data.count);
    } catch (err) {
      console.error("Error fetching programs", err);
    }
  };

  const fetchBranches = async () => {
    try {
      const res = await axios.get(
        `${API_BASE_URL}/api/dashboard/branch-count/${user.client_id}/${user.college_id}`
      );
      setBranchCount(res.data.count);
    } catch (err) {
      console.error("Error fetching branches", err);
    }
  };

  const fetchStudents = async () => {
    try {
      const res = await axios.get(
        `${API_BASE_URL}/api/dashboard/student-count/${user.client_id}/${user.college_id}`
      );
      setStudentCount(res.data.count);
    } catch (err) {
      console.error("Error fetching students", err);
    }
  };

  // ----------------------------------------
  // ROLE BASED DASHBOARD RENDERING
  // ----------------------------------------
  const renderDashboardByRole = () => {
    if (roleId === 1 || roleId === 4) {
      return (
        <Grid container spacing={3}>
          <Grid item xs={12} md={6} lg={3}>
            <ComplexStatisticsCard
              color="dark"
              icon="weekend"
              title="Programs"
              count={programCount}
              percentage={{ color: "success", amount: "+0%", label: "Active Programs" }}
            />
          </Grid>

          <Grid item xs={12} md={6} lg={3}>
            <ComplexStatisticsCard
              color="dark"
              icon="weekend"
              title="Branches"
              count={branchCount}
              percentage={{ color: "success", amount: "+0%", label: "Active Branches" }}
            />
          </Grid>

          <Grid item xs={12} md={6} lg={3}>
            <ComplexStatisticsCard
              color="success"
              icon="store"
              title="Students"
              count={studentCount}
              percentage={{ color: "success", amount: "0%", label: "Active Students" }}
            />
          </Grid>
        </Grid>
      );
    }

    if (roleId === 6) {
      return (
        <Grid container spacing={3}>
          {/* 🔥 Allotted Scripts */}
          <Grid item xs={12} md={6} lg={4}>
            <ComplexStatisticsCard
              color="info"
              icon="assignment_turned_in"
              title="Allotted Scripts"
              count={pending + completed} // 🔥 replace with your state variable
              percentage={{
                color: "success",
                amount: "+0",
                label: "Total Scripts Assigned",
              }}
            />
          </Grid>
          {/* 🔥 Pending Scripts */}
          <Grid item xs={12} md={6} lg={4}>
            <ComplexStatisticsCard
              color="warning"
              icon="hourglass_empty"
              title="Pending Scripts"
              count={pending}
              percentage={{
                color: "info",
                amount: "+0",
                label: "Scripts to Evaluate",
              }}
            />
          </Grid>

          {/* 🔥 Completed Scripts */}
          <Grid item xs={12} md={6} lg={4}>
            <ComplexStatisticsCard
              color="success"
              icon="check_circle"
              title="Completed Scripts"
              count={completed}
              percentage={{
                color: "success",
                amount: "+0",
                label: "Submitted Successfully",
              }}
            />
          </Grid>
        </Grid>
      );
    }

    return <h3 style={{ textAlign: "center" }}>No dashboard available for your role.</h3>;
  };

  return (
    <DashboardLayout>
      <DashboardNavbar />
      <MDBox sx={{ display: "flex", flexDirection: "column", minHeight: "100vh", p: 3 }}>
        {renderDashboardByRole()}
      </MDBox>
      <Footer />
    </DashboardLayout>
  );
}

export default Dashboard;
